import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-MX';
import localePt from '@angular/common/locales/pt';
import localeFr from '@angular/common/locales/fr';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

// Registrar locale español México para que el date pipe muestre
// días y meses en español en toda la aplicación.
registerLocaleData(localeEs, 'es-MX');
// Portugues de Brasil: el locale 'pt' de Angular es el de Brasil.
registerLocaleData(localePt, 'pt-BR');
// Frances de Francia: fechas como "4 oct. 2026".
registerLocaleData(localeFr, 'fr-FR');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
